export const getStoreName = (shopName: string) => {
  if (shopName.includes("UK")) return "ukamplify";
  if (shopName.includes("US")) return "balance-probiotic-skincare";
  if (shopName.includes("CA") || shopName.includes("Canada")) return "petlab-canada";
  if (shopName.includes("DE")) return "deamplify";
  if (shopName.includes("FE")) return "framplify";
  return "balance-probiotic-skincare";
};

export const getActualLink = (shopName?: string, id?: string, type = "orders"): string => {
  if (!shopName || !id) return "#";
  const storeName = getStoreName(shopName);
  if (type === "customers") {
    return `https://admin.shopify.com/store/${storeName}/orders?customer_id=${id}&customers_redirect=true`;
  }

  return `https://admin.shopify.com/store/${storeName}/orders/${id}`;
};
